import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';

class FooterLinks extends Component {
  render() {
    return(
      <Row>
        <Col md={12}>
          <a href="/gallery">GALLERY</a>
          <a href="/blog">BLOG</a>
          <a href="/about-us">ABOUT US</a>
          <a href="/contact-us">CONTACT US</a>
        </Col>

        <Col md={12}>
          <hr/>
        </Col>

        <Col md={12} className="mt-3">
          <h5 >
            We create amazing interior for people to go wow!
          </h5>
        </Col>
      </Row>
    )
  }
}

export default FooterLinks;